import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiPaymentAccountTypeQueryResponse,
  GetApiPaymentAccountType401,
  GetApiPaymentAccountType403,
} from "../../../types/GetApiPaymentAccountType";

export function getGetApiPaymentAccountTypeUrl() {
  return `/api/Payment/account-type` as const;
}

/**
 * {@link /api/Payment/account-type}
 */
export async function getApiPaymentAccountType(
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiPaymentAccountTypeQueryResponse,
    ResponseErrorConfig<
      GetApiPaymentAccountType401 | GetApiPaymentAccountType403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiPaymentAccountTypeUrl().toString(),
    ...requestConfig,
  });
  return res;
}
